/*eslint-disable */
import React, { useState } from 'react'
import {
  ButtonCsvGenerate,
  ButtonCsvGenerateText,
  GridContainer,
  OptionContainer,
  OptionCounterparty,
  ButtonTradeType,
  StackContainer,
  StyledMenuItem,
  StyledSelect,
  StyledSelectArrowIcon
} from './Reports.style'
import { Box, Button, CircularProgress, Grid, List, ListItem, Typography } from '@mui/material'
import {
  AutocompleteStyle,
  TextFieldModalStyle,
  TextFieldStyle
} from '../../components/ModalApp/ModalApp.style'
import PaperAutoComplete from '../../components/PaperAutoComplete/PaperAutoComplete'
import { CheckboxStyle, Label } from '../../components/styled/global.style'
import useAxios from '../../hooks/useAxios'
import { leToolRoutes, routes } from '../../utils/constants'
import { cleanEmptyField } from '../../helper'
import { ReactComponent as DownloadReportIcon } from '../../assets/download_report.svg'
import { handelNotifications } from '../../redux/slices/Notification/notificationSlice'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import dayjs from 'dayjs'
import SelectWithArrow from '../../components/SelectWithArrow/SelectWithArrow'

const Reports = () => {
  const [form, setForm] = useState({
    report_type: '',
    date_start: '',
    date_end: '',
    counterparty: '',
    trade_types: []
  })
  const dispatch = useDispatch()
  const [submitLoader, setSubmitLoader] = useState(false)
  const { response: dealTypes } = useAxios({ endPoint: routes.dealTypes })
  const { response: counterparty } = useAxios({ endPoint: routes.counterParty })
  const token = useSelector(state => state.auth.token)

  const handelFormChange = (event, element) => {
    const { name, value, checked } = event.target
    const copyForm = { ...form }
    if (['date_start', 'date_end'].includes(name)) {
      copyForm[name] = value
    } else if (['counterparty', 'trade_type'].includes(name)) {
      if (name === 'counterparty') {
        copyForm[name] = element.split(' ').slice(0, -1).join(' ')
      } else {
        copyForm[name] = element
      }
    } else if (['trade_types'].includes(name)) {
      if (checked) {
        copyForm[name].push(element)
      } else {
        copyForm[name] = copyForm[name].filter(data => element !== data)
      }
    } else if (name === 'all_cash') {
      copyForm.trade_types = ['Spot', 'Forward', 'NDF', 'Swap']
    } else if (name === 'all_option') {
      copyForm.trade_types = dealTypes.data
        .filter(({ name }) => !['Spot', 'NDF', 'Forward', 'Swap'].includes(name))
        .map(({ name }) => name)
    } else if (name === 'report_type') {
      copyForm[name] = value
    }
    setForm(copyForm)
  }

  const disableSubmit = () => {
    if (!form.date_end || !form.date_start || !form.report_type) {
      return true
    }
    return false
  }

  const handelSubmit = async () => {
    const copyForm = { ...form }
    copyForm.date_start = dayjs(copyForm.date_start).format('YYYYMMDD')
    copyForm.date_end = dayjs(copyForm.date_end).format('YYYYMMDD')
    const { date_start, date_end } = copyForm
    cleanEmptyField(copyForm)
    setSubmitLoader(true)
    try {
      const url = process.env.REACT_APP_SERVER_URL.concat(leToolRoutes.trades)
      const response = await axios.post(url, copyForm, {
        headers: {
          Authorization: token
        },
        params: {
          csv: true
        },
        responseType: 'blob'
      })

      const extension = `.${response.data.type}`
      if (extension.includes('csv')) {
        const urlExcelFile = window.URL.createObjectURL(new Blob([response.data]))
        const a = document.createElement('a')

        a.href = urlExcelFile
        a.download = `fxer_trades_${date_start}_${date_end}.csv`
        document.body.appendChild(a)
        a.click()
        a.remove()

        window.URL.revokeObjectURL(urlExcelFile)
      } else if (extension.includes('json')) {
        const response = await axios.post(url, copyForm, {
          headers: {
            Authorization: token
          },
          params: {
            csv: true
          }
        })
        dispatch(
          handelNotifications({
            id: Date.now(),
            type: 'success',
            message: response.data.message
          })
        )
      }
    } catch (error) {
      console.log(error)
      dispatch(
        handelNotifications({
          id: Date.now(),
          type: 'error',
          message: error?.response?.data?.message || 'csv not found'
        })
      )
    }
    setSubmitLoader(false)
  }

  return (
    <GridContainer container>
      <Grid
        item
        width={'225px'}
        style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginRight: '10px' }}
      >
        Generate Report
        <Box>
          <Label>Report Type</Label>
          <SelectWithArrow
            orderType={form.report_type}
            name="report_type"
            onChange={handelFormChange}
            background="#39393C"
            items={[{ name: 'Trade Date' }, { name: 'Value Date' }, { name: 'Expiry Date' }]}
          />
        </Box>
        <Box>
          <Label>Date Start</Label>
          <TextFieldStyle
            type="date"
            name="date_start"
            value={form.date_start}
            onChange={handelFormChange}
          />
        </Box>
        <Box>
          <Label>Date End</Label>
          <TextFieldStyle
            type="date"
            name="date_end"
            value={form.date_end}
            onChange={handelFormChange}
          />
        </Box>
        <Box>
          <Label>Counterparty</Label>
          {Array.isArray(counterparty.data) && (
            <AutocompleteStyle
              onChange={(event, element) => {
                event.target.name = 'counterparty'
                element = element ?? ''
                handelFormChange(event, element)
              }}
              size={'small'}
              value={form.counterparty}
              getOptionLabel={option => option}
              renderOption={(props, option) => {
                return (
                  <OptionContainer {...props} key={option}>
                    <Typography>{option.split(' ').slice(0, -1).join(' ')} </Typography>
                    <OptionCounterparty>{option.split(' ').at(-1)} </OptionCounterparty>
                  </OptionContainer>
                )
              }}
              options={counterparty.data.map(({ name }) => name)}
              renderInput={params => (
                <TextFieldModalStyle {...params} fullWidth autoFocus placeholder="Select Client" />
              )}
              ListboxComponent={PaperAutoComplete}
            />
          )}
        </Box>
        {!submitLoader ? (
          <ButtonCsvGenerate disabled={disableSubmit()} onClick={handelSubmit}>
            <>
              <ButtonCsvGenerateText>Generate CSV</ButtonCsvGenerateText>
              <DownloadReportIcon style={{ marginLeft: '8px' }} />
            </>
          </ButtonCsvGenerate>
        ) : (
          <Box style={{ width: '175px', textAlign: 'center' }}>
            <CircularProgress
              style={{
                marginTop: '35px',
                color: '#A4A4FF',
                height: '16px',
                width: '16px'
              }}
            />
          </Box>
        )}
      </Grid>
      <Grid style={{ marginTop: '30px', marginLeft: '69px', width: '235px' }}>
        <Label style={{ marginBottom: '14px' }}>Trade Types</Label>
        <Box style={{ marginBottom: '13px' }}>
          <ButtonTradeType
            name="all_cash"
            style={{ marginRight: '13px' }}
            onClick={handelFormChange}
          >
            All Cash
          </ButtonTradeType>
          <ButtonTradeType name="all_option" onClick={handelFormChange}>
            All Option
          </ButtonTradeType>
        </Box>
        <List
          style={{
            paddingTop: '22px',
            paddingLeft: '15px',
            paddingBottom: '32px',
            paddingRight: '16px',
            backgroundColor: '#242428',
            overflowY: 'scroll',
            maxHeight: '120px',
            display: 'flex',
            flexDirection: 'column',
            gap: '22px'
          }}
          className="container"
        >
          {Array.isArray(dealTypes.data) && (
            <>
              {dealTypes.data.map(({ name }) => (
                <ListItem key={name} disablePadding>
                  <CheckboxStyle
                    size="16px"
                    name="trade_types"
                    style={{ marginRight: '8px' }}
                    checked={form.trade_types.includes(name)}
                    onClick={event => handelFormChange(event, name)}
                  />
                  {name}
                </ListItem>
              ))}
            </>
          )}
        </List>
      </Grid>
    </GridContainer>
  )
}

export default Reports
